var LoaderLabelPositions;
(function (LoaderLabelPositions) {
  LoaderLabelPositions["Bottom"] = 'bottom';
  LoaderLabelPositions["Right"] = 'right';
})(LoaderLabelPositions || (LoaderLabelPositions = {}));
var LoaderLabels;
(function (LoaderLabels) {
  LoaderLabels["Loading"] = "Loading";
  LoaderLabels["Saving"] = "Saving";
})(LoaderLabels || (LoaderLabels = {}));
var LoaderLooks;
(function (LoaderLooks) {
  LoaderLooks["Black"] = 'black';
  LoaderLooks["Gray"] = 'gray';
  LoaderLooks["Primary"] = 'primary';
  LoaderLooks["Warning"] = 'warning';
  LoaderLooks["White"] = 'white';
})(LoaderLooks || (LoaderLooks = {}));
var LoaderSizes;
(function (LoaderSizes) {
  LoaderSizes["Large"] = 'large';
  LoaderSizes["Medium"] = 'medium';
  LoaderSizes["Small"] = 'small';
})(LoaderSizes || (LoaderSizes = {}));
var ShimmerLoaderLooks;
(function (ShimmerLoaderLooks) {
  ShimmerLoaderLooks["Default"] = 'default';
})(ShimmerLoaderLooks || (ShimmerLoaderLooks = {}));
export { LoaderLabelPositions, LoaderLabels, LoaderLooks, LoaderSizes, ShimmerLoaderLooks };